import { CX_INPUT_DATE_HIDE_RESET_BUTTON_TOKEN } from 'app/shared/cx-ui/cx-input-date/cx-input-date.config';
import { of } from 'rxjs';

export const cxDateHideResetButtonProvider = {
  provide: CX_INPUT_DATE_HIDE_RESET_BUTTON_TOKEN,
  deps: [],
  useFactory: () => {
    return of(true);
  },
};
